import styles from 'styles/shared/variables.scss';
import { uniqueService } from './unique.service';

class BrowserService {
  private _localStorageKey = 'browserUnuqieId';
  private styles: { [key: string]: string };

  constructor() {
    this.styles = styles;

    if (!this.browserUniqueId) {
      localStorage.setItem(this._localStorageKey, uniqueService.getUniqueId());
    }
  }

  get browserUniqueId() {
    return localStorage.getItem(this._localStorageKey);
  }

  isMobileDevice(): boolean {
    return window.matchMedia(`(max-width: ${this.styles.xs})`).matches;
  }
}

export const browserService = new BrowserService();
